import Pages from './pages';

export default new Pages();



// WEBPACK FOOTER //
// ./lib/engine/core/pages/index.ts